<template>
  <div class="panel">
    <div class="plan">
      <div>
        <img :src="imgUrl1" alt />
      </div>
      <div>
        <img :src="imgUrl2" alt />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    imgUrl: Array
  },
  data() {
    return {
      imgUrl1: "",
      imgUrl2: ""
    };
  },
  destroyed() {},
  mounted() {
    this.dd();
  },

  methods: {
    dd() {
      this.imgUrl1 = this.imgUrl[1];
      this.imgUrl2 = this.imgUrl[2];
    }
  }
};
</script>
<style lang="scss" scoped>
img {
  display: inline-block;
  width: 100%;
  height: 100%;
}
@import "./insurancePlan.scss";
</style>


// WEBPACK FOOTER //
// src/pages/Index/insurancePlan/index.vue